import {
  Dispatch,
  FC,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import Button from "../common/Button";
import { CloseIcon, SendIcon } from "../common/Icons";
import { Fade, Modal } from "@mui/material";
import classNames from "classnames";
import "react-phone-input-2/lib/style.css";
import { twJoin } from "tailwind-merge";
import { getLanguageCode } from "../../app/services/api";
import CommonLanguage from "../common/CommonLanguage";

import "ckeditor5/ckeditor5.css";
export type TNameOnlyPopup = {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isOpen: boolean;
  editedData?: any;
  setEditData?: any;
  savePopupData: any;
  updatePopupData: any;
  title: string;
  isSubmit: boolean;
  setIsSubmit: React.Dispatch<React.SetStateAction<boolean>>;
  uploading: boolean;
  setUploading: React.Dispatch<React.SetStateAction<boolean>>;
};
const ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];
const CreatePopupNameAndText: FC<TNameOnlyPopup> = ({
  isOpen,
  setIsOpen,
  editedData,
  setEditData,
  savePopupData,
  updatePopupData,
  title,
  isSubmit,
  setIsSubmit,
  setUploading,
  uploading,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [activeLang, setActiveLang] = useState<string>("en");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [logo, setLogo] = useState<string>("");
  const [logoFile, setLogoFile] = useState<File | undefined>();
  const [name_en, setName_en] = useState<string>("");
  const [name_tc, setName_tc] = useState<string>("");
  const [name_sc, setName_sc] = useState<string>("");
  const [link_en, setLink_en] = useState<string>("");
  const [link_tc, setLink_tc] = useState<string>("");
  const [link_sc, setLink_sc] = useState<string>("");
  const [key, setKey] = useState<string>("");
  const [order, setOrder] = useState<any>();
  const [linktype, setLinkType] = useState<string>("");
  const [isFileError, setIsFileError] = useState<boolean>(false);
  const [description_en, setDescription_en] = useState<string>("");
  const [description_tc, setDescription_tc] = useState<string>("");
  const [description_sc, setDescription_sc] = useState<string>("");
  const [id, setID] = useState<number>();
  const resetFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };
  const clearData = () => {
    setName_en("");
    setName_tc("");
    setName_sc("");
    setActiveLang("en");
    setLink_en("");
    setLink_tc("");
    setLink_sc("");
    setLogoFile(undefined);
    setLogo('');
    setKey('');
    setOrder(0);
    resetFileInput();
  };
  const checkValidation = (saveData: any) => {
    if (
      saveData.name === "" ||
      saveData.link === "") {
      return true;
    } else {
      return false;
    }
  };
  const handleSubmit = async (e: any) => {
    const formData = new FormData(e.target);
    setIsSubmit(true);
    setUploading(true);
    onFormError(formData)
    const saveData = {
      id: editedData?.id,
      name_en: formData.get('name_en'),
      name_tc: formData.get('name_tc'),
      name_sc: formData.get('name_sc'),
      link_en: update_link_for_internal(editedData['key'])?update_link_for_internal(editedData['key']):formData.get('link_en'),
      link_tc: update_link_for_internal(editedData['key'])?update_link_for_internal(editedData['key']):formData.get('link_tc'),
      link_sc: update_link_for_internal(editedData['key'])?update_link_for_internal(editedData['key']):formData.get('link_sc'),
      logo: logoFile,
      order: formData.get('order'),
      key: editedData?.key,
      parent_id: editedData?.parent_id
    };
    const check = checkValidation(saveData);
    if (!check) {
      if (editedData) {
        updatePopupData(saveData);
      } else {
        savePopupData(saveData);
      }
    } else {
      setUploading(false);
    }
  };
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file: any = e.target.files?.[0];
    if (file) {
      const isValid = ALLOWED_TYPES.includes(file.type);
      if (!isValid) {
        setIsFileError(true);
      } else {
        setIsFileError(false);
        setLogoFile(file)
        setLogo(URL.createObjectURL(file));
      }
    }
  };
  const update_link_for_internal = (key: string) => {
    if (key === 'manuals') {
      return '/profile/manuals';
    }
    else if (key === 'notices') {
      return '/profile/notice_board';
    }
    else if (key === 'profile') {
      return '/profile';
    }else{
      return null;
    }
  }

  useEffect(() => {
    if (editedData) {
      setID(editedData.id);
      setName_en(editedData["name_en"]);
      setName_tc(editedData["name_tc"]);
      setName_sc(editedData["name_sc"]);
      setLink_en(editedData["link_en"]);
      setLink_tc(editedData["link_tc"]);
      setLink_sc(editedData["link_sc"]);
      setLogo(editedData["logo"]);
      setLogoFile(undefined);
      setKey(editedData['key']);
      setOrder(editedData['order'] ? Number(editedData['order']) : 0);
    }
  }, [editedData]);
  useEffect(() => {
    if (!editedData) {
      clearData();
    }
    setActiveLang("en");
  }, [isOpen, editedData]);
  const changeLanguage = (code: string) => {
    setActiveLang(code);
  };
  const onFormError = (formData: any) => {
    if (!formData.get('name_tc')) {
      changeLanguage('tc');
      return;
    } else if (!formData.get('name_sc')) {
      changeLanguage('sc');
      return;
    } else if (!formData.get('name_en')) {
      changeLanguage('en');
      return;
    }else{
      changeLanguage('en');
      return;
    }
  };

  return (
    <Modal
      className=""
      open={isOpen}
      style={{
        background: "rgb(0 0 0 / 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClose={(event, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          setIsOpen(false);
          setEditData("");
          setIsSubmit(false);
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={isOpen} timeout={500}>
        <div className="lg:max-w-[800px] max-w-full w-full m-auto">
          <div className="modalContent w-full h-full p-6 lg:p-0 flex justify-center items-center relative z-[999]">
            <div className="rounded-xl bg-white font-primary w-full">
              <div
                id="modal-modal-title"
                className="bg-vorpblue relative flex justify-between py-6 sm:px-10 px-5 rounded-t-xl"
              >
                <h3 className="text-18 leading-[27px] font-semibold text-white">
                  {title}
                </h3>
                <button
                  key={Math.random() * 100}
                  type="button"
                  aria-label="Close Modal"
                  onClick={() => {
                    setIsOpen(false);
                    setIsSubmit(false);
                    setEditData("");
                    setUploading(false);
                    setErrorMsg("");
                    clearData();
                  }}
                >
                  <CloseIcon />
                </button>
              </div>
              <form onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(e);
              }} action=''
                id="modal-modal-description"
                className="pb-9 px-5 bg-white rounded-b-xl  overflow-y-auto max-h-[70vh] h-full custom_scrollbar_popup"
              >
                <div className="flex flex-col justify-between w-full ">
                  <CommonLanguage
                    changeLanguage={changeLanguage}
                    activeLang={activeLang}
                  />
                  <div
                    className={twJoin(
                      activeLang == "en" ? "" : "hidden",
                      "mb-0 last:mb-0 w-full px-3"
                    )}
                  >
                    <div>
                      <label className="text-black2 text-15 font-medium font-primary mt-[0.600rem] block mb-[0.688rem]">
                        Name<span className=" text-red-500">*</span>
                      </label>
                      <input required name="name_en"
                        defaultValue={name_en}
                        type="text"
                        placeholder="Name"
                        className="focus:outline-none focus-visible:outline-none w-full rounded py-3.5 px-3 border border-goalinputborder text-black2 text-14 font-medium font-primary placeholder:text-graydark h-[48px]"
                      ></input>
                    </div>
                    {(key !== 'manuals' && key !== 'notices' && key !== 'profile') && <div className={twJoin("mb-0 last:mb-0 w-full")}>
                      <label className="text-black2 text-15 font-medium font-primary mt-[0.600rem] block mb-[0.688rem]">
                        Link<span className=" text-red-500">*</span>
                      </label>
                      <input required name="link_en"
                        defaultValue={link_en}
                        type="text"
                        placeholder="Link"
                        className="focus:outline-none focus-visible:outline-none w-full rounded py-3.5 px-3 border border-goalinputborder text-black2 text-14 font-medium font-primary placeholder:text-graydark h-[48px]"
                      ></input>
                    </div>}
                  </div>
                  <div
                    className={twJoin(
                      activeLang == "tc" ? "" : "hidden",
                      "mb-0 last:mb-0 w-full px-3"
                    )}
                  >
                    <div>
                      <label className="text-black2 text-15 font-medium font-primary mt-[0.600rem] block mb-[0.688rem]">
                        Name<span className=" text-red-500">*</span>
                      </label>
                      <input required name="name_tc"
                        defaultValue={name_tc}
                        type="text"
                        placeholder="Name"
                        className="focus:outline-none focus-visible:outline-none w-full rounded py-3.5 px-3 border border-goalinputborder text-black2 text-14 font-medium font-primary placeholder:text-graydark h-[48px]"
                      ></input>
                    </div>
                    {(key !== 'manuals' && key !== 'notices' && key !== 'profile') && <div className={twJoin("mb-0 last:mb-0 w-full")}>
                      <label className="text-black2 text-15 font-medium font-primary mt-[0.600rem] block mb-[0.688rem]">
                        Link<span className=" text-red-500">*</span>
                      </label>
                      <input name="link_tc"
                        defaultValue={link_tc}
                        type="text"
                        placeholder="Link"
                        className="focus:outline-none focus-visible:outline-none w-full rounded py-3.5 px-3 border border-goalinputborder text-black2 text-14 font-medium font-primary placeholder:text-graydark h-[48px]"
                      ></input>
                    </div>}
                  </div>
                  <div
                    className={twJoin(
                      activeLang == "sc" ? "" : "hidden",
                      "mb-0 last:mb-0 w-full px-3"
                    )}
                  >
                    <div>
                      <label className="text-black2 text-15 font-medium font-primary mt-[0.600rem] block mb-[0.688rem]">
                        Name<span className=" text-red-500">*</span>
                      </label>
                      <input required name="name_sc"
                        defaultValue={name_sc}
                        type="text"
                        placeholder="Name"
                        className="focus:outline-none focus-visible:outline-none w-full rounded py-3.5 px-3 border border-goalinputborder text-black2 text-14 font-medium font-primary placeholder:text-graydark h-[48px]"
                      ></input>
                    </div>
                    {(key !== 'manuals' && key !== 'notices' && key !== 'profile') && <div className={twJoin("mb-0 last:mb-0 w-full")}>
                      <label className="text-black2 text-15 font-medium font-primary mt-[0.600rem] block mb-[0.688rem]">
                        Link<span className=" text-red-500">*</span>
                      </label>
                      <input
                        defaultValue={link_sc} name="link_sc"
                        type="text"
                        placeholder="Link"
                        className="focus:outline-none focus-visible:outline-none w-full rounded py-3.5 px-3 border border-goalinputborder text-black2 text-14 font-medium font-primary placeholder:text-graydark h-[48px]"
                      ></input>
                    </div>}
                  </div>

                </div>
                <div className="px-3 create-popup">
                  <div className={twJoin("mb-0 last:mb-0 w-full")}>
                    <label className="text-black2 text-15 font-medium font-primary mt-[0.600rem] block mb-[0.688rem]">
                      Logo<span className=" text-red-500">*</span>
                    </label>
                    {logo
                      ? <div className="relative inline-block">
                        <img
                          src={logo}
                          className=" max-w-[100px] w-full min-w-[100px] mb-5 aspect-[100/100] object-contain"
                        />
                        {/* <button className="absolute right-[-10px] top-[-10px]" onClick={() => handleRemove()}><CloseIcon color="#9e3039" /></button> */}
                      </div>
                      : null}
                    <div className=" border border-gray-300 text-gray-400">
                      <div className="flex items-center p-4 relative">
                        <input ref={fileInputRef} required={logo ? false : true}
                          type="file" onChange={handleFileChange}
                          name="meta_image"
                          className="focus:outline-none absolute opacity-0 focus-visible:outline-none w-full rounded py-3.5 px-3 border border-goalinputborder text-black2 text-14 font-medium font-primary placeholder:text-graydark"
                        />
                        <button type="button" className="whitespace-nowrap text-black2 text-15 font-medium font-primary">Choose file</button>
                        <p className="font-primary text-10 sm:text-12 text-black2 ml-3 " style={{ wordBreak: 'break-word' }}>
                          {logo ? logo.split('/')[logo.split('/').length - 1] : ''}
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
                <div className={twJoin("mb-0 last:mb-0 w-full px-3")}>
                  <label className="text-black2 text-15 font-medium font-primary mt-[0.600rem] block mb-[0.688rem]">
                    Order<span className=" text-red-500">*</span>
                  </label>
                  <input required name="order"
                    value={order}
                    onChange={(e) => {
                      if (e.target.value) {
                        setOrder(Number(e.target.value))
                      } else {
                        setOrder(null)
                      }
                    }}
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Order No"
                    className="focus:outline-none focus-visible:outline-none w-full rounded py-3.5 px-3 border border-goalinputborder text-black2 text-14 font-medium font-primary placeholder:text-graydark h-[48px]"
                  />
                </div>
                <div className="px-2 pb-5 pt-5 flex justify-between items-center">
                  <div className="flex flex-wrap">
                    <div className="flex px-2 justify-center items-center">
                      <button
                        type="submit"
                        className={classNames(
                          uploading ? " pointer-events-none opacity-50" : "",
                          "rounded-md bg-vorpblue text-white hover:bg-transparent border border-vorpblue hover:text-white transition-all duration-300 hover:bg-vorpblue mr-2 py-2 lg:py-2 px-3 custom-button-size"
                        )}
                      >
                        <span className="flex items-center text-12 leading-[18px]">
                          <SendIcon className="mr-[10px] group-hover:opacity-0 transition-all duration-300" />
                          {editedData ? "Update" : "Save"}
                        </span>
                      </button>

                      <Button
                        type="button"
                        label={
                          <span className="flex items-center text-12 leading-[18px] ">
                            <CloseIcon
                              width={14}
                              height={14}
                              className="mr-[10px] [&_path]:fill-graydark"
                            />
                            Cancel
                          </span>
                        }
                        onClick={() => {
                          setIsOpen(false);
                          setIsSubmit(false);
                          setEditData("");
                          setErrorMsg("");
                          clearData();
                          setUploading(false);
                          setIsSubmit(false);
                        }}
                        variant="no-outline"
                        size="lg"
                        customClass=" mr-2 py-2 lg:py-2 px-3 bg-offwhite text-black2 border-none custom-button-size"
                      />
                    </div>
                  </div>
                  <p
                    className={classNames(
                      isSubmit || errorMsg ? "" : "hidden",
                      "mb-2 font-poppins text-12 text-redPink"
                    )}
                  >
                    {errorMsg}
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default CreatePopupNameAndText;
